if (!customElements.get("variant-select")) {
  class VariantSelect extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      const jsonEl = this.querySelector('script[type="application/json"]')
      if (!jsonEl) return

      this.variants = JSON.parse(jsonEl.textContent)
      this.selects = this.querySelectorAll("select[data-option-position]")
      this.buttonGroups = this.querySelectorAll("[data-option-buttons]")

      this.selects.forEach((select) => select.addEventListener("change", this.onVariantChange.bind(this)))

      this.buttonGroups.forEach((group) => {
        group.querySelectorAll("button").forEach((btn) =>
          btn.addEventListener("click", () => {
            group.querySelectorAll("button").forEach((b) => b.setAttribute("aria-pressed", "false"))
            btn.setAttribute("aria-pressed", "true")
            this.onVariantChange()
          })
        )
      })

      this.onVariantChange()
    }

    onVariantChange() {
      const selectedOptions = []

      this.buttonGroups.forEach((group) => {
        const selectedBtn = group.querySelector("[aria-pressed='true']")
        selectedOptions[group.dataset.optionPosition - 1] = selectedBtn?.dataset.value
      })

      this.selects.forEach((select) => {
        selectedOptions[select.dataset.optionPosition - 1] = select.value
      })

      const matched = this.variants.find(
        (v) =>
          (v.option1 === null || selectedOptions[0] === undefined || v.option1 === selectedOptions[0]) &&
          (v.option2 === null || selectedOptions[1] === undefined || v.option2 === selectedOptions[1]) &&
          (v.option3 === null || selectedOptions[2] === undefined || v.option3 === selectedOptions[2])
      )

      if (matched) {
        this.dispatchEvent(
          new CustomEvent("variant:change", {
            bubbles: true,
            detail: { variant: matched },
          })
        )
      }
    }
  }
  customElements.define("variant-select", VariantSelect)
}

if (!customElements.get("product-infos")) {
  class ProductInfos extends HTMLElement {
    connectedCallback() {
      this.addEventListener("variant:change", this.onVariantChange.bind(this))

      const raw = this.dataset.currentVariantJson
      this.initialColor = this.getVariantColor(raw)
    }

    getVariantColor(variantJson) {
      if (!variantJson) return null
      try {
        const variant = JSON.parse(variantJson)
        return variant.option2
      } catch {
        return null
      }
    }

    onVariantChange(event) {
      const variant = event.detail.variant
      if (!variant) return

      const idInputs = this.querySelectorAll('input[name="id"]')
      idInputs.forEach((input) => {
        input.value = variant.id
        input.dispatchEvent(new Event("change", { bubbles: true }))
      })

      const newColor = variant.option2
      let newUrl = `${this.dataset.url || window.location.pathname}?variant=${variant.id}`

      if (variant.url) {
        newUrl = variant.url
      }

      if (newColor !== this.initialColor) {
        window.location.href = newUrl
        return
      }

      if (this.dataset.updateUrl !== "false") {
        window.history.replaceState({}, "", newUrl)
      }
    }
  }
  customElements.define("product-infos", ProductInfos)
}

if (!customElements.get("recently-viewed-products")) {
  class RecentlyViewedProducts extends HTMLElement {
    async connectedCallback() {
      const currentHandle = this.dataset.handle
      const title = this.dataset.title || "Recently Viewed"
      const soldOutLabel = this.dataset.soldOut || "Sold Out"
      const key = "recentlyViewedHandles"
      let handles = JSON.parse(localStorage.getItem(key)) || []
      handles = handles.filter((h) => h !== currentHandle)
      handles.unshift(currentHandle)
      handles = handles.slice(0, 10)
      localStorage.setItem(key, JSON.stringify(handles))
      const container = document.createElement("div")
      container.className = "product-recently-viewed page-width my-10 mb-14"
      container.style.display = "none"
      container.innerHTML = `
        <h3 class="heading--tertairy mb-3 font-bold">${title}</h3>
        <ul class="flex items-center overflow-x-auto whitespace-nowrap gap-2 scrollbar-hidden list-none" role="list"></ul>
      `
      this.appendChild(container)
      const list = container.querySelector("ul")
      let count = 0

      for (const handle of handles) {
        if (handle === currentHandle) continue
        try {
          const res = await fetch(`${window.Shopify.routes.root}products/${handle}.js`)
          const product = await res.json()
          const variant = product.variants[0]
          const price = Shopify.formatMoney(variant.price)
          const compareAt = variant.compare_at_price ? Shopify.formatMoney(variant.compare_at_price) : null
          const discountPercent = variant.compare_at_price
            ? Math.round(100 - (variant.price / variant.compare_at_price) * 100)
            : 0

          const li = document.createElement("li")
          li.className = "flex-1 w-full min-w-52 lg:min-w-60 xl:min-w-[280px] max-w-[280px]"
          li.innerHTML = `
            <div class="product-card h-full relative">
              <div class="product-image relative aspect-[4/5] overflow-hidden">
                ${
                  !product.available
                    ? `<span class="absolute top-0 left-0 z-10 text-xs font-bold text-white bg-neutral-800 px-2 py-0.5">${soldOutLabel}</span>`
                    : compareAt
                      ? `<span class="absolute top-0 left-0 z-10 text-xs font-bold text-white  bg-neutral-800 px-2 py-0.5">-${discountPercent}%</span>`
                      : ""
                }
                <a href="${product.url}" class="relative group flex items-center justify-center border bg-white">
                  <img src="${product.featured_image}" alt="${product.title}" loading="lazy"
                    class="object-contain aspect-[4/5] transition-opacity transition-transform group-hover:scale-105" />
                </a>
              </div>
              <div class="py-2 space-y-1">
                <p class="font-bold text-sm leading-tight text-center">
                  <a href="${product.url}" class="w-full text-wrap text-sm leading-snug">${product.title.split(",")[0]}</a>
                </p>
                <div class="flex items-center justify-center gap-1.5 flex-wrap text-sm">
                  <div class="product-price flex items-center flex-wrap gap-2">
                    ${
                      variant.compare_at_price > variant.price
                        ? `<span class="text-neutral-500 line-through text-sm">${compareAt}</span>
                          <span class="text-neutral-800 font-bold text-base">${price}</span>`
                        : `<span class="text-neutral-800 font-bold text-sm">${price}</span>`
                    }
                  </div>
                </div>
              </div>
            </div>
          `
          list.appendChild(li)
          count++
        } catch (error) {
          console.warn(`Could not load product: ${handle}`, error)
        }
      }
      if (count > 0) container.style.display = "block"
    }
  }
  customElements.define("recently-viewed-products", RecentlyViewedProducts)
}

;(() => {
  // This script is for the dimension display functionality
  const selectEl = document.getElementById("unit-select")
  const displayEl = document.getElementById("dimension-value")
  const rawVal = document.getElementById("dimension-value")

  const parseDimensions = (value) =>
    value
      ?.replace(/cm/gi, "")
      .split("x")
      .map((v) => parseFloat(v.trim().replace(",", ".")))
      .filter((v) => !isNaN(v)) || []
  const convertToFeet = (cm) => (cm / 30.48).toFixed(2)
  const formatDimensions = (dims, unit) =>
    dims.map((val) => (unit === "cm" ? val : convertToFeet(val))).join(" x ") + " " + unit
  const updateDisplay = (unit) => {
    const dims = parseDimensions(rawVal.dataset.dimention)
    displayEl.textContent = dims.length ? formatDimensions(dims, unit) : "Invalid dimensions"
  }
  if (!selectEl) return
  selectEl.addEventListener("change", (e) => updateDisplay(e.target.value))
  updateDisplay("cm")
  // end of dimension display functionality

  // This script will make the add to cart sticky
  const observer = new IntersectionObserver(
    ([entry]) => {
      const stickyAddToCart = document.getElementById("stickyAddToCart")
      if (!stickyAddToCart) return
      const bounding = entry.boundingClientRect
      const isAboveScreen = bounding.bottom < 0
      if (isAboveScreen) {
        stickyAddToCart.classList.add("translate-y-0")
        stickyAddToCart.classList.remove("translate-y-full")
      } else {
        stickyAddToCart.classList.remove("translate-y-0")
        stickyAddToCart.classList.add("translate-y-full")
      }
    },
    { root: null, threshold: 0 }
  )
  const waitForElement = (selector, callback) => {
    const el = document.querySelector(selector)
    if (el) return callback(el)
    const mo = new MutationObserver(() => {
      const el = document.querySelector(selector)
      if (el) {
        mo.disconnect()
        callback(el)
      }
    })
    mo.observe(document.documentElement, { childList: true, subtree: true })
  }
  waitForElement("#addToCartButton", (addToCartButton) => {
    observer.observe(addToCartButton)
  })
  // end of sticky add to cart functionality
})()
